import { useCallback } from 'react';
import { ReactEditor } from 'slate-react';
import { useRecoilState } from 'recoil';
import { lineIndicatorState } from 'domains/reporter/Reporter/state';
import { Range } from '../core';

/**
 * Shows the line indicator when a selection is collapsed.
 */
export const useLineIndicator = () => {
  const [lineIndicatorRef, setLineIndicatorRef] = useRecoilState(lineIndicatorState);

  const updatePosition = useCallback(
    // @ts-expect-error [EN-10263] - TS7031 - Binding element 'editor' implicitly has an 'any' type. | TS7031 - Binding element 'selection' implicitly has an 'any' type.
    ({ editor, selection }) => {
      setTimeout(() => {
        try {
          if (Range.isExpanded(selection)) {
            setLineIndicatorRef(null);
            return;
          }

          const domRange = ReactEditor.toDOMRange(editor, selection);
          setLineIndicatorRef(domRange);
        } catch (e) {
          setTimeout(() => {
            const domSelection = window.getSelection();
            if (domSelection != null && domSelection.rangeCount > 0) {
              const domRange = domSelection.getRangeAt(0);
              setLineIndicatorRef(domRange);
            }
          }, 0);
        }
      }, 0);
    },
    [setLineIndicatorRef]
  );

  return {
    lineIndicatorRef,
    setLineIndicatorRef,
    updatePosition,
  };
};
